const PRODUCTION_SITE_URL = 'https://lensbank.com.tw';

function normalizeBaseUrl(url: string): string {
  return url.trim().replace(/\/+$/, '');
}

function isLocalhostUrl(url: string): boolean {
  try {
    const { hostname } = new URL(url);
    return (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0' ||
      hostname === '::1'
    );
  } catch {
    return url.includes('localhost');
  }
}

/**
 * Auth redirect base URL helper.
 * Supabase email links must never point to localhost; local fallback uses the production customer site.
 */
export function getAuthRedirectBaseUrl(): string {
  const envRedirect = import.meta.env.VITE_AUTH_REDIRECT_BASE_URL as string | undefined;
  if (envRedirect && typeof envRedirect === 'string' && envRedirect.trim().length > 0) {
    const normalized = normalizeBaseUrl(envRedirect);
    if (!isLocalhostUrl(normalized)) return normalized;
    console.warn('[authRedirect] Ignoring localhost VITE_AUTH_REDIRECT_BASE_URL for Supabase email redirect.');
  }

  const envSiteUrl = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined;
  if (envSiteUrl && typeof envSiteUrl === 'string' && envSiteUrl.trim().length > 0) {
    const normalized = normalizeBaseUrl(envSiteUrl);
    if (!isLocalhostUrl(normalized)) return normalized;
    console.warn('[authRedirect] Ignoring localhost VITE_PUBLIC_SITE_URL for Supabase email redirect.');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    if (!isLocalhostUrl(window.location.origin)) return normalizeBaseUrl(window.location.origin);
  }

  return PRODUCTION_SITE_URL;
}

/** 重設密碼 redirect URL */
export function getResetPasswordRedirectUrl(): string {
  return `${getAuthRedirectBaseUrl()}/account/reset-password`;
}

/** 註冊 email 確認 redirect URL — 改為 /account/auth/callback（正式 callback）*/
export function getConfirmEmailRedirectUrl(): string {
  return `${getAuthRedirectBaseUrl()}/account/auth/callback`;
}

/**
 * 公開前端 base URL helper
 * 用於給員工/客戶看的連結（打卡入口、LIFF 等）
 *
 * 優先順序：
 * 1. VITE_PUBLIC_SITE_URL — 公開站點 URL（最優先）
 * 2. VITE_AUTH_REDIRECT_BASE_URL — 手動指定
 * 3. window.location.origin — runtime fallback
 */
export function getPublicFrontendBaseUrl(): string {
  const envSiteUrl = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined;
  if (envSiteUrl && typeof envSiteUrl === 'string' && envSiteUrl.trim().length > 0) {
    return envSiteUrl.trim();
  }

  const envRedirect = import.meta.env.VITE_AUTH_REDIRECT_BASE_URL as string | undefined;
  if (envRedirect && typeof envRedirect === 'string' && envRedirect.trim().length > 0) {
    return envRedirect.trim();
  }

  return window.location.origin;
}
